import React from 'react';
import ShareArticle from "../ShareArticle";

const FormationPageSidebar = ({data, cleanHTML}) => {
    const combinedCategories = [
        ...(data?.prerequis || []),
    ];

    return (
            <>
                <div className="widget">
                    <div className="widget-content">
                        <div className="ls-outer">
                            {combinedCategories.length > 0 ? (
                                <div className="candidate-block-three">
                                    <div className="inner-box" style={{display: "grid"}}>
                                        {combinedCategories.map((option) => (
                                            <div className="content mb-1 mt-1">
                                                <div className="block block1">
                                                    <figure className="image">
                                                        <img src={option.oneIcon} alt={option.titre} />
                                                    </figure>
                                                </div>
                                                <div className="block block2">
                                                    <span className="name">{option.titre}</span>
                                                </div>
                                                <div className="block block3 mt-2 mb-2">
                                                    {option.description ? cleanHTML(option.description) : ''}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : null}

                            {data?.modalites?.map((option) => (
                                <div className="candidate-block-three" key={option.id} style={{padding: 0}}>
                                    <div className="inner-box">
                                        <div className="content mb-1 mt-1">
                                            <div className="block block1">
                                                <figure className="image">
                                                    <img src={option.oneIcon} alt={option.titre}/>
                                                </figure>
                                            </div>
                                            <div className="block block2">
                                                <span className="name">{option.titre}</span>
                                            </div>
                                            <div className="block block3 mt-2 mb-2">
                                                {option.description ? cleanHTML(option.description) : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {data?.prix?.map((option) => (
                                <div className="candidate-block-three" key={option.id} style={{padding: 0}}>
                                    <div className="inner-box">
                                        <div className="content mb-1 mt-1">
                                            <div className="block block1">
                                                <figure className="image">
                                                    <img src={option.oneIcon} alt={option.titre}/>
                                                </figure>
                                            </div>
                                            <div className="block block2">
                                                <span className="name">{option.titre}</span>
                                            </div>
                                            <div className="block block3 mt-2 mb-2">
                                                {option.description ? cleanHTML(option.description) : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {data && (
                                <div className="candidate-block-three">
                                    <ShareArticle
                                        url={window.location.href}
                                        title={data?.titre}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>
    );
};

export default FormationPageSidebar;
